import * as permissions from '@/utils/permissions'
import * as roles from '@/utils/roles'
import { DISCOUNT_SETUP_VIEW, LOCATION_VIEW, STRAIN_VIEW, TRANSFER_ADD } from '../../../utils/permissions'
const {
  USER_ADD,
  USER_VIEW,
  ROLE_VIEW,
  SUPPLIER_ADD,

  SUPPLIER_VIEW,
  PATIENT_ADD,
  PATIENT_VIEW,
  TRANSPORTER_ADD,
  TRANSPORTER_VIEW,
  EXPENSE_CATEGORY_ADD,
  EXPENSE_CATEGORY_VIEW,
  EXPENSE_ADD,
  EXPENSE_VIEW,
  CLIENT_ADD,
  CLIENT_VIEW,
  SUPPLIER_IMPORT,
  CLIENT_IMPORT,
  PATIENT_IMPORT,
  TRANSPORTER_IMPORT,
  BATCH_ADD,
  BATCH_VIEW,
  PLANT_VIEW,
  INVENTORY_ADD,
  INVENTORY_VIEW,
  PRODUCT_CATEGORY_ADD,
  PRODUCT_CATEGORY_VIEW,
  PRODUCT_ADD,
  PRODUCT_VIEW,
  TAX_VIEW,
  SALE_ADD,
  SALE_VIEW,
  LAB_ADMIN_VIEW,
  LAB_TESTING_ADD,
  LAB_TESTING_VIEW,
  SALES_RETURN_REPORT,
  EXPENSE_REPORT,
  TAX_REPORT,
  STOCK_REPORT,
  ITEM_SALES_REPORT,
  SALES_PAYMENT_REPORT,
  SALES_REPORT,
  PROFIT_AND_LOSS_REPORT,
  PROCESSOR_REPORT,
  DISPENSARY_REPORT,
  CULTIVATOR_REPORT,
  PRODUCT_HISTORICAL_REPORT,
  PRODUCT_IMPORT,
  CASH_DROP_ADD,
  CASH_DROP_VIEW,
  REGISTER_ADD,
  REGISTER_VIEW,
  CASH_FLOAT_ADD,
  CASH_FLOAT_VIEW,
  CASH_DROP_REPORT,
  CASH_FLOAT_REPORT,
  PUNCH_CLOCK_ADD,
  PUNCH_CLOCK_VIEW,
  PROMO_DISCOUNT_VIEW,
  MARKET_PLACE_VIEW,
  REWARDS_DISCOUNT,
  TIRED_PRICING
} = permissions
const { ADMIN } = roles
const ALLPERMISSIONS = [...Object.values(permissions)]
const ALLROLES = [...Object.values(roles)]
const ALL_REPORT_PERMISSIONS = [
  SALES_RETURN_REPORT,
  EXPENSE_REPORT,
  TAX_REPORT,
  STOCK_REPORT,
  ITEM_SALES_REPORT,
  SALES_PAYMENT_REPORT,
  SALES_REPORT,
  PROFIT_AND_LOSS_REPORT,
  PROCESSOR_REPORT,
  DISPENSARY_REPORT,
  CULTIVATOR_REPORT,
  PRODUCT_HISTORICAL_REPORT
]
export default [
  // dashboard
  {
    url: '/dashboard',
    name: 'Dashboard',
    slug: 'Dashboard',
    icon: 'HomeIcon',
    permissions: ALLPERMISSIONS,
    roles: ALLROLES
  },
  // marketplace
  {
    url: '/marketplace',
    name: 'Market Place',
    slug: 'MarketPlace',
    icon: 'ShoppingBagIcon',
    // tag: 'new',
    tagColor: 'success',
    permissions: [MARKET_PLACE_VIEW]
  },
  // sales
  {
    url: null,
    name: 'Sales',
    slug: 'Sales',
    icon: 'ShoppingCartIcon',
    permissions: [SALE_ADD, SALE_VIEW, CASH_FLOAT_ADD, CASH_FLOAT_VIEW, CASH_DROP_ADD, CASH_DROP_VIEW],
    submenu: [
      {
        url: '/pos',
        name: 'POS',
        slug: 'POS',
        icon: 'LayoutIcon',
        permissions: [SALE_ADD]
      },
      {
        url: '/pos/invoice-list',
        name: 'Invoice List',
        slug: 'InvoiceList',
        icon: 'ListIcon',
        permissions: [SALE_VIEW]
      },
      {
        url: '/cash-drop/create',
        name: 'Add Cash Drop',
        slug: 'AddCashDrop',
        icon: 'PlusIcon',
        permissions: [CASH_DROP_ADD]
      },
      {
        url: '/cash-drop/list',
        name: 'Cash Drop List',
        slug: 'CashDropList',
        icon: 'ListIcon',
        permissions: [CASH_DROP_VIEW]
      },
      {
        url: '/cash-float/create',
        name: 'Add Cash Float',
        slug: 'AddCashFloat',
        icon: 'PlusIcon',
        permissions: [CASH_FLOAT_ADD]
      },
      {
        url: '/cash-float/list',
        name: 'Cash Float List',
        slug: 'CashFloatList',
        icon: 'ListIcon',
        permissions: [CASH_FLOAT_VIEW]
      }
    ]
  },
  // Contacts
  {
    header: 'Contacts',
    slug: 'Contacts',
    icon: 'UserIcon',
    permissions: [
      USER_ADD,
      USER_VIEW,
      ROLE_VIEW,
      SUPPLIER_ADD,
      SUPPLIER_VIEW,
      SUPPLIER_IMPORT,
      PATIENT_ADD,
      PATIENT_VIEW,
      TRANSPORTER_ADD,
      TRANSPORTER_VIEW,
      CLIENT_IMPORT,
      PATIENT_IMPORT,
      TRANSPORTER_IMPORT
    ],
    items: [
      {
        url: null,
        name: 'Suppliers',
        slug: 'Suppliers',
        icon: 'ShoppingBagIcon',
        permissions: [SUPPLIER_VIEW],
        submenu: [
          {
            url: '/suppliers/list',
            name: 'Suppliers List',
            slug: 'SuppliersList',
            icon: 'ListIcon',
            permissions: [SUPPLIER_VIEW]
          },
          {
            url: '/suppliers/import',
            name: 'Import',
            slug: 'ImportCsv',
            icon: 'ListIcon',
            tag: 'new',
            tagColor: 'success',
            permissions: [SUPPLIER_IMPORT]
          }
        ]
      },
      {
        url: null,
        name: 'Patients',
        slug: 'Patients',
        icon: 'ActivityIcon',
        permissions: [PATIENT_ADD, PATIENT_VIEW],
        submenu: [
          {
            url: '/patients/create',
            name: 'Add Patient',
            slug: 'AddPatient',
            icon: 'PlusIcon',
            permissions: [PATIENT_ADD]
          },
          {
            url: '/patients/list',
            name: 'Patients List',
            slug: 'PatientsList',
            icon: 'ListIcon',
            permissions: [PATIENT_VIEW]
          },
          {
            url: '/patients/import',
            name: 'Import',
            slug: 'ImportCsv',
            icon: 'ListIcon',
            tag: 'new',
            tagColor: 'success',
            permissions: [PATIENT_IMPORT]
          }
        ]
      },
      {
        url: null,
        name: 'Transporters',
        slug: 'Transporters',
        icon: 'TruckIcon',
        permissions: [TRANSPORTER_VIEW, TRANSPORTER_IMPORT],
        submenu: [
          {
            url: '/transporters/list',
            name: 'Transporter List',
            slug: 'TransporterList',
            icon: 'ListIcon',
            permissions: [TRANSPORTER_VIEW]
          },
          {
            url: '/transporters/import',
            name: 'Import',
            slug: 'ImportCsv',
            icon: 'ListIcon',
            tag: 'new',
            tagColor: 'success',
            permissions: [TRANSPORTER_IMPORT]
          }
        ]
      },
      {
        url: null,
        name: 'Clients',
        slug: 'Clients',
        icon: 'BriefcaseIcon',
        permissions: [CLIENT_ADD, CLIENT_VIEW],
        submenu: [
          {
            url: '/clients/create',
            name: 'Add Client',
            slug: 'AddClient',
            icon: 'PlusIcon',
            permissions: [CLIENT_ADD]
          },
          {
            url: '/clients/list',
            name: 'Clients List',
            slug: 'ClientsList',
            icon: 'ListIcon',
            permissions: [CLIENT_VIEW]
          },
          {
            url: '/clients/import',
            name: 'Import',
            slug: 'ImportCsv',
            icon: 'ListIcon',
            tag: 'new',
            tagColor: 'success',
            permissions: [CLIENT_IMPORT]
          }
        ]
      }
    ]
  },
  // product
  {
    header: 'Product',
    slug: 'Product',
    icon: 'InboxIcon',
    permissions: [PRODUCT_CATEGORY_ADD, PRODUCT_CATEGORY_VIEW, PRODUCT_ADD, PRODUCT_VIEW, PRODUCT_IMPORT, INVENTORY_ADD, INVENTORY_VIEW, LAB_TESTING_ADD, LAB_TESTING_VIEW, LAB_ADMIN_VIEW],
    roles: [ADMIN],
    items: [
      // product category
      {
        url: null,
        name: 'Product Category',
        slug: 'Product Category',
        icon: 'InboxIcon',
        permissions: [PRODUCT_CATEGORY_ADD, PRODUCT_CATEGORY_VIEW],
        submenu: [
          {
            url: '/category/create',
            name: 'Add Category',
            slug: 'AddCategory',
            icon: 'PlusIcon',
            permissions: [PRODUCT_CATEGORY_ADD]
          },
          {
            url: '/category/list',
            name: 'Category List',
            slug: 'CategoryList',
            icon: 'ListIcon',
            permissions: [PRODUCT_CATEGORY_VIEW]
          }
        ]
      },
      // product
      {
        url: null,
        name: 'Product',
        slug: 'Product',
        icon: 'TrelloIcon',
        permissions: [PRODUCT_ADD, PRODUCT_VIEW, PRODUCT_IMPORT],
        submenu: [
          {
            url: '/products/create',
            name: 'Add Product',
            slug: 'AddProduct',
            icon: 'PocketIcon',
            permissions: [PRODUCT_ADD]
          },
          {
            url: '/products/list',
            name: 'Product List',
            slug: 'ProductList',
            icon: 'ListIcon',
            permissions: [PRODUCT_VIEW]
          },
          {
            url: '/products/import',
            name: 'Import',
            slug: 'ImportProduct',
            icon: 'ListIcon',
            tag: 'new',
            tagColor: 'success',
            permissions: [PRODUCT_IMPORT]
          }
        ]
      },
      // lab
      {
        url: null,
        name: 'Lab',
        slug: 'Lab',
        icon: 'TrelloIcon',
        roles: [ADMIN],
        submenu: [
          {
            url: '/lab/create',
            name: 'Create Lab',
            slug: 'CreateLab',
            icon: 'ThermometerIcon',
            roles: [ADMIN]
          },
          {
            url: '/lab/list',
            name: 'Lab List',
            slug: 'LabList',
            icon: 'ListIcon',
            roles: [ADMIN]
          }
        ]
      },
      // admin lab test
      {
        url: null,
        name: 'Lab Admin',
        slug: 'LabAdmin',
        icon: 'BoxIcon',
        permissions: [LAB_ADMIN_VIEW],
        submenu: [
          {
            url: '/lab-admin',
            name: 'Lab Test List',
            slug: 'LabTestList',
            icon: 'ListIcon',
            permissions: [LAB_ADMIN_VIEW]
          }
        ]
      },
      // lab test
      {
        url: null,
        name: 'Lab Test',
        slug: 'LabTest',
        icon: 'FilterIcon',
        permissions: [LAB_TESTING_ADD, LAB_TESTING_VIEW],
        submenu: [
          {
            url: '/lab-test/add',
            name: 'Add Lab Test',
            slug: 'LabTestAdd',
            icon: 'PocketIcon',
            permissions: [LAB_TESTING_ADD]
          },
          {
            url: '/lab-test/list',
            name: 'Lab Test List',
            slug: 'LabTestList',
            icon: 'ListIcon',
            permissions: [LAB_TESTING_VIEW]
          }
        ]
      },
      // inventory
      {
        url: null,
        name: 'Inventory',
        slug: 'Inventory',
        icon: 'ClipboardIcon',
        permissions: [INVENTORY_ADD, INVENTORY_VIEW],
        submenu: [
          {
            url: '/inventory/create',
            name: 'Add Inventory',
            slug: 'AddInventory',
            icon: 'PlusIcon',
            permissions: [INVENTORY_ADD]
          },
          {
            url: '/inventory/list',
            name: 'Inventory List',
            slug: 'InventoryList',
            icon: 'FileTextIcon',
            permissions: [INVENTORY_VIEW]
          }
        ]
      },
      // tranfers
      {
        url: null,
        name: 'Transfer',
        slug: 'Transfer',
        icon: 'InboxIcon',
        permissions: [TRANSFER_ADD],
        submenu: [
          {
            url: '/transfer/list',
            name: 'Transfer List',
            slug: 'TransferList',
            icon: 'ListIcon',
            permissions: [TRANSFER_ADD]
          }
        ]
      }
    ]
  },
  // batch
  {
    url: null,
    name: 'Batch',
    slug: 'Batch',
    icon: 'PackageIcon',
    permissions: [BATCH_ADD, BATCH_VIEW, PLANT_VIEW],
    submenu: [
      {
        url: '/batches/create',
        name: 'Add Batch',
        slug: 'AddBatch',
        icon: 'PlusIcon',
        permissions: [BATCH_ADD]
      },
      {
        url: '/batches/list',
        name: 'Batch List',
        slug: 'BatchList',
        icon: 'FileTextIcon',
        permissions: [BATCH_VIEW]
      },
      {
        url: '/plants/list',
        name: 'Plant List',
        slug: 'PlantList',
        icon: 'SunriseIcon',
        permissions: [PLANT_VIEW]
      }
    ]
  },
  // report
  {
    url: null,
    name: 'Reports',
    slug: 'ReportsSales',
    icon: 'ActivityIcon',
    permissions: ALL_REPORT_PERMISSIONS,
    submenu: [
      {
        url: '/reports/sales-return',
        name: 'Sales Return Report',
        slug: 'SalesReturnReport',
        icon: 'FileTextIcon',
        tag: 'new',
        tagColor: 'success',
        permissions: [SALES_RETURN_REPORT]
      },
      {
        url: '/reports/expense',
        name: 'Expense Report',
        slug: 'ExpenseReport',
        icon: 'FileTextIcon',
        permissions: [EXPENSE_REPORT]
      },
      {
        url: '/reports/tax',
        name: 'Tax Report',
        slug: 'TaxReport',
        icon: 'FileTextIcon',
        permissions: [TAX_REPORT]
      },
      {
        url: '/reports/stock',
        name: 'Stock Report',
        slug: 'StockReport',
        icon: 'FileTextIcon',
        tag: 'new',
        tagColor: 'success',
        permissions: [STOCK_REPORT]
      },
      {
        url: '/reports/item-sales',
        name: 'Item Sales Report',
        slug: 'ItemSalesReport',
        icon: 'FileTextIcon',
        permissions: [ITEM_SALES_REPORT]
      },
      {
        url: '/reports/sales-payment',
        name: 'Sales Payment Report',
        slug: 'SalesPaymentReport',
        icon: 'FileTextIcon',
        permissions: [SALES_PAYMENT_REPORT]
      },
      {
        url: '/reports/sales',
        name: 'Sales Report',
        slug: 'SalesReport',
        icon: 'FileTextIcon',
        permissions: [SALES_REPORT]
      },
      // {
      //   url: '/reports/profit-loss',
      //   name: 'Profit and Loss Report',
      //   slug: 'ProfitAndLossReport',
      //   icon: 'FileTextIcon',
      //   tag: 'new',
      //   tagColor: 'success',
      //   permissions: [PROFIT_AND_LOSS_REPORT]
      // },
      {
        url: '/reports/processor',
        name: 'Processor Report',
        slug: 'ProcessorReport',
        icon: 'FileTextIcon',
        permissions: [PROCESSOR_REPORT]
      },
      {
        url: '/reports/dispensary',
        name: 'Dispensary Report',
        slug: 'DispensaryReport',
        icon: 'FileTextIcon',
        permissions: [DISPENSARY_REPORT]
      },
      {
        url: '/reports/cultivator',
        name: 'Cultivator Report',
        slug: 'CultivatorReport',
        icon: 'FileTextIcon',
        permissions: [CULTIVATOR_REPORT]
      },
      {
        url: '/reports/cash-drop',
        name: 'Cash Drop Report',
        slug: 'CashDropReport',
        icon: 'FileTextIcon',
        permissions: [CASH_DROP_REPORT]
      },
      {
        url: '/reports/cash-float',
        name: 'Cash Float Report',
        slug: 'CashFloatReport',
        icon: 'FileTextIcon',
        permissions: [CASH_FLOAT_REPORT]
      },
      {
        url: '/reports/ProductHistorical',
        name: 'Product Historical Report',
        slug: 'ProductHistoricalReport',
        icon: 'FileTextIcon',
        permissions: [PRODUCT_HISTORICAL_REPORT]
      }
    ]
  },
  // settings
  {
    url: null,
    name: 'Settings',
    slug: 'Settings',
    icon: 'SettingsIcon',
    roles: ALLROLES,
    permissions: ALLPERMISSIONS,
    submenu: [
      {
        url: '/settings/stock-photo',
        name: 'Stock Photo Gallery',
        slug: 'ProductList',
        icon: 'ImageIcon',
        tag: 'new',
        tagColor: 'success',
        roles: [ADMIN]
      },
      // {
      //   url: '/settings/spf-records',
      //   name: 'SPF Records / Receipts',
      //   slug: 'SPFRecordsReceipts',
      //   icon: 'DollarSignIcon',
      //   permissions: [ADMIN]
      // },
      {
        url: '/settings/tax-list',
        name: 'Tax Setup',
        slug: 'TaxList',
        icon: 'PercentIcon',
        permissions: [TAX_VIEW]
      },
      {
        url: '/settings/discount-setup',
        name: 'Discount Setup',
        slug: 'Discount/Tax Setup',
        icon: 'PercentIcon',
        permissions: [DISCOUNT_SETUP_VIEW]
      },
      {
        url: '/profile',
        name: 'Update Profile',
        slug: 'UpdateProfile',
        icon: 'UserIcon',
        permissions: ALLPERMISSIONS,
        roles: ALLROLES
      },
      {
        url: '/roles/list',
        name: 'Roles List',
        slug: 'RolesList',
        icon: 'ListIcon',
        tag: 'new',
        tagColor: 'success',
        permissions: [ROLE_VIEW]
      },
      {
        url: '/settings/tiered-pricing',
        name: 'Tiered Pricing Group',
        slug: 'TieredPricingGroup',
        icon: 'PercentIcon',
        permissions: [TIRED_PRICING]
      },
      {
        url: '/settings/reward-setup',
        name: 'Reward Setup',
        slug: 'Reward Setup',
        icon: 'ListIcon',
        tag: 'new',
        tagColor: 'success',
        permissions: [REWARDS_DISCOUNT]
      },
      {
        url: '/register/create',
        name: 'Add Register',
        slug: 'AddRegister',
        icon: 'PlusSquareIcon',
        permissions: [REGISTER_ADD]
      },
      {
        url: '/register/list',
        name: 'Register List',
        slug: 'RegisterList',
        icon: 'ListIcon',
        permissions: [REGISTER_VIEW]
      },
      {
        url: '/settings/terms-condition',
        name: 'Terms Condition',
        slug: 'TermsCondition',
        icon: 'HelpCircleIcon',
        roles: [ADMIN]
      },
      {
        url: '/strains/list',
        name: 'Strain List',
        slug: 'StrainList',
        icon: 'SunriseIcon',
        permissions: [STRAIN_VIEW]
      },
      {
        url: '/promo-discount/list',
        name: 'Promo Discount',
        slug: 'PromoDiscount',
        icon: 'PercentIcon',
        permissions: [PROMO_DISCOUNT_VIEW]
      },
      {
        url: '/location/list',
        name: 'Location List',
        slug: 'LocationList',
        icon: 'FileTextIcon',
        permissions: [LOCATION_VIEW]
      }
    ]
  },
  // HR
  {
    url: null,
    name: 'HR',
    slug: 'HR',
    icon: 'DollarSignIcon',
    permissions: [PUNCH_CLOCK_ADD, PUNCH_CLOCK_VIEW, USER_ADD, USER_VIEW, EXPENSE_ADD, EXPENSE_VIEW, EXPENSE_CATEGORY_ADD, EXPENSE_CATEGORY_VIEW],
    submenu: [
      {
        url: '/punch-clock/list',
        name: 'Punch Clock List',
        slug: 'PunchClockList',
        icon: 'WatchIcon',
        permissions: [PUNCH_CLOCK_VIEW]
      },
      {
        url: '/punch-clock/create',
        name: 'Punch Clock',
        slug: 'PunchClock',
        icon: 'WatchIcon',
        permissions: [PUNCH_CLOCK_ADD]
      },
      {
        url: '/users/create',
        name: 'Add User',
        slug: 'AddUser',
        icon: 'PlusIcon',
        permissions: [USER_ADD]
      },
      {
        url: '/users/list',
        name: 'Users List',
        slug: 'UsersList',
        icon: 'ListIcon',
        permissions: [USER_VIEW]
      },
      // expenses
      {
        url: null,
        name: 'Expense',
        slug: 'Expense',
        icon: 'SlidersIcon',
        permissions: [EXPENSE_ADD, EXPENSE_VIEW, EXPENSE_CATEGORY_ADD, EXPENSE_CATEGORY_VIEW],
        submenu: [
          {
            url: '/expense-category/create',
            name: 'Add Expense Category',
            slug: 'AddExpenseCategory',
            icon: 'PlusIcon',
            permissions: [EXPENSE_CATEGORY_ADD]
          },
          {
            url: '/expense-category/list',
            name: 'Expense Category List',
            slug: 'ExpenseCategoryList',
            icon: 'ListIcon',
            permissions: [EXPENSE_CATEGORY_VIEW]
          },
          {
            url: '/expense/create',
            name: 'Add Expense ',
            slug: 'AddExpense',
            icon: 'PlusIcon',
            permissions: [EXPENSE_ADD]
          },
          {
            url: '/expense/list',
            name: 'Expense List',
            slug: 'ExpenseList',
            icon: 'ListIcon',
            permissions: [EXPENSE_VIEW]
          }
        ]
      }
    ]
  }
]
